import type { IxmUserauthV1OrganizationKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const USERAUTH_ORGANIZATION_BASE_PATH = getResolvedPath('/organization');

export const getOrganizationPath: EntityPathBuilder<IxmUserauthV1OrganizationKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return USERAUTH_ORGANIZATION_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.organizationId) {
        return undefined;
      }

      return getResolvedPath(`${USERAUTH_ORGANIZATION_BASE_PATH}/$organizationId`, context.keys);
    }
  }
};

export function getOrganizationDetailPath(organizationId: string | undefined) {
  if (!organizationId) {
    return undefined;
  }

  return getOrganizationPath({ kind: 'detail', keys: { organizationId } });
}
